import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { SubPageHeader } from "../app/header";
import { Session } from "../../models/session/session";
import { ActivePageType, NavigationBar } from "../app/navigation";
import { IUserState } from "../../models/store/storeTypes";
import { ISessionState } from "../../models/session/sessionState";
import { IUserIdCardItem } from "../../models/userIdCard/userIdCardItem";

//UserIdCardView
export interface IUserIdCardViewOwnProps {
}

export interface IUserIdCardViewStateProps {
    user: IUserState;
    item: IUserIdCardItem;
}

export interface IUserIdCardViewDispatchProps {
    loadUserIdCardItem: () => void;
    onLogout: () => void;
}

type UserIdCardViewProp = IUserIdCardViewOwnProps & IUserIdCardViewStateProps & IUserIdCardViewDispatchProps;

export interface IUserIdCardViewState {
    sessionState: ISessionState;
}

export class UserIdCardView extends React.Component<UserIdCardViewProp, IUserIdCardViewState> {
    private hasBeenInitialized: boolean;

    constructor(props) {
        super(props);
        this.hasBeenInitialized = false;
        this.state = {
            sessionState: null
        };
    }

    componentDidMount(): void {
        const props = this.props;
        props.loadUserIdCardItem();
        Session.getSessionStateIndexedDb()
            .then((sessionState) => {
                this.setState({
                    sessionState
                });
            });
        this.hasBeenInitialized = true;
    }

    render() {
        const props = this.props;
        const state = this.state;
        const item = props.item;
        if (!item) return null;
        return (
            <div>
                <div className="pageContentContainer frontPage">
                    <div className="identityCardContainer">
                        <div className="identityCard">
                            <div className="upperPart">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="control-label">{Translations.Name}</label>
                                            <div>{item.firstName + " " + item.lastName}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="control-label">{Translations.TaxNumber}</label>
                                            <div>{item.taxNumber}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="control-label">{Translations.Company}</label>
                                            <div className="companyContainer">
                                                {!!state.sessionState?.companyLogo &&
                                                    <img alt="..." src={"data:image/png;base64," + state.sessionState?.companyLogo} />
                                                }
                                                <div className="name">{state.sessionState?.companyName ?? ""}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label className="control-label">{Translations.BusinessIdentityCode}</label>
                                            <div>{item.companyBusinessIdentityCode}</div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label className="control-label">{Translations.Validity}</label>
                                            <div className={item.archived ? "badText" : ""}>{(item.archived ? Translations.Expired : Translations.IndefinitelyNoLocalization).toLocaleLowerCase()}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="lowerPart">
                                {!!item.picture &&
                                    <img alt="..." src={item.picture} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <NavigationBar
                    activePage={ActivePageType.FurtherEducation}
                    user={props.user}
                />
                <SubPageHeader
                    user={props.user}
                    title={Translations.IdCard}
                />
            </div>
        );
    }
}